export const ADVANCED_REPORTING_INSIGHTS_SCOPE = 'advanced-reporting-insights';